// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"71b6baaf","337":"491c66de","453":"90f75ba3","667":"a6c40a65"}[chunkId] + ".chunk.js";
};